<div class="rating" (mouseleave)="resetHover(propertyIndex)">
  <ng-container *ngFor="let star of stars; let starIndex = index">
    <i
      class="fa"
      [ngClass]="{
        'fa-star': isFullStar(propertyIndex, starIndex),
        'fa-star-half-o': isHalfStar(propertyIndex, starIndex),
        'fa-star-o': isEmptyStar(propertyIndex, starIndex),
        hovered: starIndex <= hoverIndexes[propertyIndex],
        removing: isRemoving(propertyIndex, starIndex)
      }"
      (mouseenter)="onHover(propertyIndex, starIndex)"
      (click)="handleClick($event, propertyIndex, starIndex)"
    ></i>
  </ng-container>
</div>
